import React from "react";
import { ArrowUpDown, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { SORT_OPTIONS } from "./clientsUi";

export default function SortMenu({ value, onChange, className = "" }) {
  const current = SORT_OPTIONS.find((o) => o.key === value);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={`h-11 px-4 rounded-md border border-border bg-white text-sm inline-flex items-center justify-center gap-2 hover:border-neutral-300 ${className}`} data-testid="clients-sort-button">
          <ArrowUpDown className="w-4 h-4 text-neutral-500" strokeWidth={1.6} />
          <span className="truncate">Ordina{current && value !== "wedding_date_asc" ? <span className="hidden sm:inline text-neutral-500"> · {current.label}</span> : null}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[230px] rounded-md">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-neutral-500">Ordina per</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SORT_OPTIONS.map((o) => (
          <DropdownMenuItem key={o.key} onClick={() => onChange(o.key)} className="flex items-center justify-between" data-testid={`sort-${o.key}`}>
            {o.label}
            {o.key === value && <Check className="w-4 h-4 text-primary" strokeWidth={2} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
